import Api from '../service/Api';

export default {
  biometriaValid: (renach, cpf, image, momento) => Api.post('biometriaMA', {
    renach: renach,
    cpf: cpf,
    base64: image,
    momento: momento
  }),
};
